<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content
        [showDefaultFormFooter]="true"
        updateButtonLabel="Move here"
        [contentClasses]="['']"
    >
        <div class="move-file-modal-content">
            <div class="folder-info mb-3">
                <p>
                    <strong>Moving:</strong> {{ fileEntry?.name }}
                    <span *ngIf="fileEntry?.is_dir">(Folder)</span>
                    <span *ngIf="!fileEntry?.is_dir">(File)</span>
                </p>
                <p class="text-sm text-gray-600">Select a destination folder:</p>
            </div>

            <p-tree
                [value]="folderTree"
                selectionMode="single"
                [(selection)]="selectedFolder"
                (onNodeSelect)="onNodeSelect($event)"
                (onNodeUnselect)="onNodeUnselect()"
                [style]="{'min-height': '300px', 'max-height': '400px', 'overflow': 'auto'}"
            >
                <ng-template pTemplate="empty">
                    <span class="text-gray-500">No folders available</span>
                </ng-template>
            </p-tree>

            <div class="mt-3 text-sm text-gray-600" *ngIf="fileEntry?.is_dir">
                <i class="pi pi-info-circle"></i>
                Note: You cannot move a folder into itself or its subfolders.
            </div>
        </div>
    </app-ibase-cru-modal-content>
</form>
